import { createMuiTheme, PaletteType } from "@material-ui/core";
import { inject, observer } from "mobx-react";

import { ThemeProvider } from "@material-ui/styles";

import React from "react";

import { IConfigStoreProps } from "../stores/IConfigStoreProps";
import { PredefinedStoreName } from "./enums/PredefinedStoreName";

import Shell from "./shell/Shell";

interface IAppState {
    hasError: boolean;
    eventId?: string;
}

@inject(PredefinedStoreName.CONFIG)
@observer
class App extends React.Component<IConfigStoreProps, IAppState> {

    /**
     * Creates an instance of App.
     * @param {IConfigStoreProps} props
     * @memberof App
     */
    constructor(props: IConfigStoreProps) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    public render() {

        const {me}  = this.props.configStore!;

        let paletteType: PaletteType = "dark";

        if (!!me) {
            paletteType = me.theme;
        }

        const theme = createMuiTheme({
            palette: {
                primary: {
                    main: "#393C6D",
                },
                secondary: {
                    main: "#00a152",
                },
                type: paletteType,
            },
        });

        return <ThemeProvider theme={theme}>
            <Shell />
        </ThemeProvider>;
    }
}

export default App;
